import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  styled,
  Tooltip,
  tooltipClasses,
} from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { toast } from "sonner";
import axiosInstance from "../../Axios";
import renderCellExpand from "../../components/rendercellexpand/renderCellExpand";
import TopWidgets from "../../components/topwidgets/TopWidgets";
import useAuth from "../../contexts/UserContext.tsx";
import AddSchoolModal from "../../components/formmodals/addschoolmodal/AddSchoolModal.jsx";
import { Plus } from "lucide-react";

const Schools = () => {
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} placement="right" />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 14,
    },
  }));
  const handleTimeframeChange = (timeframe) => {
    if (timeframe === "cumulative") {
      setColumns([
        {
          field: "school_name",
          headerName: "School",
          flex: 3,
          minWidth: 400,
          renderCell: (params) => (
            <LightTooltip
              style={{ whiteSpace: "pre-wrap" }}
              title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
            >
              <Link
                className="text-[#8884d8] hover:underline"
                to={`/school/${params.row.school_id}`}
              >
                {renderCellExpand(params)}
              </Link>
            </LightTooltip>
          ),
        },
        {
          field: "center_cnt",
          headerName: "No of Centers",
          minWidth: 50,
          flex: 1,
        },
        {
          field: "teacher_cnt",
          headerName: "No of Teachers",
          minWidth: 10,
          flex: 1,
        },
        {
          field: "video_usage_cnt",
          headerName: "Video usage (mins)",
          minWidth: 40,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Video usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "excs_usage_cnt",
          headerName: "Exercise Usage",
          width: 10,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Exercise usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "hm_name",
          headerName: "HM name",
          // width: 150,
          flex: 2,
        },
        {
          field: "hm_phone",
          headerName: "HM Phone",
          width: 100,
          flex: 1,
        },
      ]);
    } else if (timeframe === "monthly") {
      setColumns([
        {
          field: "school_name",
          headerName: "School",
          flex: 3,
          minWidth: 400,
          renderCell: (params) => (
            <LightTooltip
              style={{ whiteSpace: "pre-wrap" }}
              title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
            >
              <Link
                className="text-[#8884d8] hover:underline"
                to={`/school/${params.row.school_id}`}
              >
                {renderCellExpand(params)}
              </Link>
            </LightTooltip>
          ),
        },
        {
          field: "center_cnt",
          headerName: "No of Centers",
          minWidth: 50,
          flex: 1,
        },
        {
          field: "teacher_cnt",
          headerName: "No of Teachers",
          minWidth: 10,
          flex: 1,
        },
        {
          field: "monthly_video_usage_cnt",
          headerName: "Video usage (mins)",
          minWidth: 40,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Video usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "monthly_excs_usage_cnt",
          headerName: "Exercise Usage",
          width: 10,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Exercise usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "hm_name",
          headerName: "HM name",
          // width: 150,
          flex: 2,
        },
        {
          field: "hm_phone",
          headerName: "HM Phone",
          width: 100,
          flex: 1,
        },
      ]);
    } else if (timeframe === "quaterly") {
      setColumns([
        {
          field: "school_name",
          headerName: "School",
          flex: 3,
          minWidth: 400,
          renderCell: (params) => (
            <LightTooltip
              style={{ whiteSpace: "pre-wrap" }}
              title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
            >
              <Link
                className="text-[#8884d8] hover:underline"
                to={`/school/${params.row.school_id}`}
              >
                {renderCellExpand(params)}
              </Link>
            </LightTooltip>
          ),
        },
        {
          field: "center_cnt",
          headerName: "No of Centers",
          minWidth: 50,
          flex: 1,
        },
        {
          field: "teacher_cnt",
          headerName: "No of Teachers",
          minWidth: 10,
          flex: 1,
        },
        {
          field: "quaterly_video_usage_cnt",
          headerName: "Video usage (mins)",
          minWidth: 40,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Video usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "quaterly_excs_usage_cnt",
          headerName: "Exercise Usage",
          width: 10,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Exercise usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "hm_name",
          headerName: "HM name",
          // width: 150,
          flex: 2,
        },
        {
          field: "hm_phone",
          headerName: "HM Phone",
          width: 100,
          flex: 1,
        },
      ]);
    } else if (timeframe === "yearly") {
      setColumns([
        {
          field: "school_name",
          headerName: "School",
          flex: 3,
          minWidth: 400,
          renderCell: (params) => (
            <LightTooltip
              style={{ whiteSpace: "pre-wrap" }}
              title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
            >
              <Link
                className="text-[#8884d8] hover:underline"
                to={`/school/${params.row.school_id}`}
              >
                {renderCellExpand(params)}
              </Link>
            </LightTooltip>
          ),
        },
        {
          field: "center_cnt",
          headerName: "No of Centers",
          minWidth: 50,
          flex: 1,
        },
        {
          field: "teacher_cnt",
          headerName: "No of Teachers",
          minWidth: 10,
          flex: 1,
        },
        {
          field: "yearly_video_usage_cnt",
          headerName: "Video usage (mins)",
          minWidth: 40,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Video usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "yearly_excs_usage_cnt",
          headerName: "Exercise Usage",
          width: 10,
          flex: 1,
          renderHeader: (params) => {
            return (
              <div
                style={{
                  whiteSpace: "pre-wrap",
                  wordWrap: "break-word",
                  lineHeight: "1.2",
                }}
              >
                {"Exercise usage\n(mins)"}
              </div>
            );
          },
        },
        {
          field: "hm_name",
          headerName: "HM name",
          // width: 150,
          flex: 2,
        },
        {
          field: "hm_phone",
          headerName: "HM Phone",
          width: 100,
          flex: 1,
        },
      ]);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer
        sx={{ padding: 2, display: "flex", justifyContent: "space-between" }}
      >
        <GridToolbarQuickFilter inputRef={quickFilterRef} />
        <div className="flex gap-4">
          <select
            className="form-control w-[200px]"
            id="district"
            value={selectedTimeframe}
            onChange={(e) => {
              handleTimeframeChange(e.target.value);
              setSelectedTimeframe(e.target.value);
            }}
          >
            <option value="cumulative">Cumulative</option>
            <option value="monthly">Current month</option>
            <option value="quaterly">Last 3 months</option>
            <option value="yearly">Last year</option>
          </select>
          <div className="flex gap-4 items-center">
            <Button
              variant="outlined"
              className="flex items-center"
              onClick={() => setAddSchoolModalOpen(true)}
            >
              <Plus size={16} className="mr-1" />
              Add School
            </Button>
            <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
          </div>
        </div>
      </GridToolbarContainer>
    );
  }
  const [selectedTimeframe, setSelectedTimeframe] = useState("cumulative");
  const [columns, setColumns] = useState([
    {
      field: "school_name",
      headerName: "School",
      flex: 3,
      minWidth: 400,
      renderCell: (params) => (
        <LightTooltip
          style={{ whiteSpace: "pre-wrap" }}
          title={`ID: ${params.row.school_id}, Type: ${params.row.school_type} District:${params.row.dist_name}`}
        >
          <Link
            className="text-[#8884d8] hover:underline"
            to={`/school/${params.row.school_id}`}
          >
            {renderCellExpand(params)}
          </Link>
        </LightTooltip>
      ),
    },
    {
      field: "center_cnt",
      headerName: "No of Centers",
      minWidth: 50,
      flex: 1,
    },
    {
      field: "teacher_cnt",
      headerName: "No of Teachers",
      minWidth: 10,
      flex: 1,
    },
    {
      field: "video_usage_cnt",
      headerName: "Video usage (mins)",
      minWidth: 40,
      flex: 1,
      renderHeader: (params) => {
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              lineHeight: "1.2",
            }}
          >
            {"Video usage\n(mins)"}
          </div>
        );
      },
    },
    {
      field: "excs_usage_cnt",
      headerName: "Exercise Usage",
      width: 10,
      flex: 1,
      renderHeader: (params) => {
        return (
          <div
            style={{
              whiteSpace: "pre-wrap",
              wordWrap: "break-word",
              lineHeight: "1.2",
            }}
          >
            {"Exercise usage\n(mins)"}
          </div>
        );
      },
    },
    {
      field: "hm_name",
      headerName: "HM name",
      // width: 150,
      flex: 2,
    },
    {
      field: "hm_phone",
      headerName: "HM Phone",
      width: 100,
      flex: 1,
    },
  ]);

  const quickFilterRef = React.useRef(null);
  const { user, logout } = useAuth();
  const school_types = user.view_access_list.school_types
    .split(",")
    .map((word) => `'${word}'`)
    .join(",");
  const school_type_array = Array.from(
    new Set(school_types.replaceAll("'", "").split(",").sort())
  ).map((school_type) => ({ label: school_type, value: school_type }));

  const district_names = user.view_access_list.district
    .split(",")
    .map((word) => `'${word}'`)
    .join(",");
  const district_names_array = Array.from(
    new Set(district_names.replaceAll("'", "").split(",").sort())
  ).map((district_name) => ({ label: district_name, value: district_name }));

  const [schoolKPIByDistrict, setSchoolKPIByDistrict] = useState();
  const [schoolSummaryList, setSchoolSummaryList] = useState();

  const [selectedSchoolTypes, setSelectedSchoolTypes] = useState(
    sessionStorage.getItem("S_lastSelectedSchoolTypes")
      ? JSON.parse(sessionStorage.getItem("S_lastSelectedSchoolTypes"))
      : school_type_array.map((option) => option.value)
  );
  const [selectedDistrictNames, setSelectedDistrictNames] = useState(
    sessionStorage.getItem("S_lastSelectedDistricts")
      ? JSON.parse(sessionStorage.getItem("S_lastSelectedDistricts"))
      : district_names_array.map((option) => option.value)
  );

  const [selectedSchoolString, setSelectedSchoolString] = useState(
    selectedSchoolTypes.map((word) => `'${word}'`).join(",")
  );
  const [selectedDistrictString, setSelectedDistrictString] = useState(
    selectedDistrictNames.map((word) => `'${word}'`).join(",")
  );

  const [reload, setReload] = useState(false);
  const [addSchoolModalOpen, setAddSchoolModalOpen] = useState(false);
  const [pageSize, setPageSize] = useState(25);

  const getSchoolSummaryList = async () => {
    const school = selectedSchoolTypes.map((word) => `'${word}'`).join(",");
    const district = selectedDistrictNames.map((word) => `'${word}'`).join(",");
    try {
      const requests = [
        axiosInstance.post("/getSchoolSummaryListByDistrict", {
          user_id: user.user_id,
          auth_token: user.auth_token,
          school_types: school,
          district_names: district,
        }),
        axiosInstance.post("/getSchoolMonthlySummaryListByDistrict", {
          user_id: user.user_id,
          auth_token: user.auth_token,
          school_types: school,
          district_names: district,
        }),
        axiosInstance.post("/getSchoolYearlySummaryListByDistrict", {
          user_id: user.user_id,
          auth_token: user.auth_token,
          school_types: school,
          district_names: district,
        }),
      ];
      const [res1, res2, res3] = await Promise.all(requests);
      if (res1.data.data.message === "Invalid User") {
        toast.error("Invalid User");
        logout();
        return;
      }
      const monthlySummaryList = res2.data.data.school_monthly_summary_list;
      const yearlySummaryList = res3.data.data.school_yearly_summary_list;
      const formattedData = res1.data.data.school_summary_list.map((school) => {
        const { school_id } = school;
        const monthlyData = monthlySummaryList[school_id];
        const yearlyData = yearlySummaryList[school_id];

        if (!monthlyData || !yearlyData) {
          return {
            ...school,
            center_cnt: parseInt(school.center_cnt, 10),
            teacher_cnt: parseInt(school.teacher_cnt, 10),
            video_usage_cnt: parseInt(school.video_usage_cnt, 10),

            monthly_video_usage_cnt: 0,
            quaterly_video_usage_cnt: 0,
            yearly_video_usage_cnt: 0,
            excs_usage_cnt: parseInt(school.excs_usage_cnt, 10),
            monthly_excs_usage_cnt: 0,
            quaterly_excs_usage_cnt: 0,
            yearly_excs_usage_cnt: 0,
          };
        }

        return {
          ...school,
          center_cnt: parseInt(school.center_cnt, 10),
          teacher_cnt: parseInt(school.teacher_cnt, 10),
          video_usage_cnt: isNaN(parseInt(school.video_usage_cnt, 10))
            ? 0
            : parseInt(school.video_usage_cnt, 10),
          monthly_video_usage_cnt: isNaN(
            parseInt(school.video_usage_cnt, 10) -
              parseInt(monthlyData[3]?.video_count, 10)
          )
            ? 0
            : parseInt(school.video_usage_cnt, 10) -
              parseInt(monthlyData[3]?.video_count, 10),
          quaterly_video_usage_cnt: isNaN(
            parseInt(school.video_usage_cnt, 10) -
              parseInt(monthlyData[0]?.video_count, 10)
          )
            ? 0
            : parseInt(school.video_usage_cnt, 10) -
              parseInt(monthlyData[0]?.video_count, 10),
          yearly_video_usage_cnt: isNaN(
            parseInt(school.video_usage_cnt, 10) -
              parseInt(yearlyData[0].video_count, 10)
          )
            ? 0
            : parseInt(school.video_usage_cnt, 10) -
              parseInt(yearlyData[0].video_count, 10),
          excs_usage_cnt: isNaN(parseInt(school.excs_usage_cnt, 10))
            ? 0
            : parseInt(school.excs_usage_cnt, 10),
          monthly_excs_usage_cnt: isNaN(
            parseInt(school.excs_usage_cnt, 10) -
              parseInt(monthlyData[3]?.excs_count, 10)
          )
            ? 0
            : parseInt(school.excs_usage_cnt, 10) -
              parseInt(monthlyData[3]?.excs_count, 10),

          quaterly_excs_usage_cnt: isNaN(
            parseInt(school.excs_usage_cnt, 10) -
              parseInt(monthlyData[0]?.excs_count, 10)
          )
            ? 0
            : parseInt(school.excs_usage_cnt, 10) -
              parseInt(monthlyData[0]?.excs_count, 10),
          yearly_excs_usage_cnt: isNaN(
            parseInt(school.excs_usage_cnt, 10) -
              parseInt(yearlyData[0].excs_count, 10)
          )
            ? 0
            : parseInt(school.excs_usage_cnt, 10) -
              parseInt(yearlyData[0].excs_count, 10),
        };
      });
      return formattedData;
    } catch (err) {
      console.error(err.message);
      throw new Error(err.message);
    }
  };

  const handleFilterClick = async () => {
    sessionStorage.setItem(
      "S_lastSelectedSchoolTypes",
      JSON.stringify(selectedSchoolTypes)
    );
    sessionStorage.setItem(
      "S_lastSelectedDistricts",
      JSON.stringify(selectedDistrictNames)
    );
    const school_str = selectedSchoolTypes.map((word) => `'${word}'`).join(",");
    const district_str = selectedDistrictNames
      .map((word) => `'${word}'`)
      .join(",");
    setSelectedDistrictString(district_str);
    setSelectedSchoolString(school_str);

    try {
      const res1 = await axiosInstance.post("/getSchoolKPIByDistrict", {
        user_id: user.user_id,
        auth_token: user.auth_token,
        school_types: school_str,
        district_names: district_str,
      });
      setSchoolKPIByDistrict(res1.data.data.school_kpi);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleSelectAllChange = () => {
    // If all checkboxes are already selected, unselect them. Otherwise, select all.
    if (selectedSchoolTypes.length === school_type_array.length) {
      setSelectedSchoolTypes([]);
    } else {
      setSelectedSchoolTypes(school_type_array.map((option) => option.value));
    }
  };

  const handleSelectAllChangeDistrict = () => {
    // If all checkboxes are already selected, unselect them. Otherwise, select all.
    if (selectedDistrictNames.length === district_names_array.length) {
      setSelectedDistrictNames([]);
    } else {
      setSelectedDistrictNames(
        district_names_array.map((option) => option.value)
      );
    }
  };

  const { data, error, isLoading } = useQuery({
    queryKey: [
      "schoolSummaryData",
      selectedSchoolString,
      selectedDistrictString,
    ],
    queryFn: getSchoolSummaryList,
    retry: 1,
    staleTime: 5 * 60 * 1000, // Cache the data for 5 minutes
    keepPreviousData: true, // Keep previous data while fetching new data
  });

  useEffect(() => {
    if (data) {
      setSchoolSummaryList(data);
    }
    if (error) {
      toast.error(error.message);
    }
  }, [data, error]);

  useEffect(() => {
    handleTimeframeChange(selectedTimeframe);
  }, [selectedTimeframe]);

  useEffect(() => {
    handleFilterClick();
    if (reload) {
      setReload(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  return (
    <div className="schools p-2">
      <div className="flex justify-around gap-2 mb-2">
        <FormControl fullWidth>
          <InputLabel id="checkbox-dropdown-label">School Types</InputLabel>
          <Select
            labelId="checkbox-dropdown-label"
            id="checkbox-dropdown"
            multiple
            label="School Types"
            value={selectedSchoolTypes}
            onChange={() => {}}
            renderValue={(selected) => [...selected].join(", ")}
          >
            <MenuItem key="select-all" onClick={handleSelectAllChange}>
              <FormControlLabel
                control={
                  <Checkbox
                    indeterminate={
                      selectedSchoolTypes.length > 0 &&
                      selectedSchoolTypes.length < school_type_array.length
                    }
                    checked={
                      selectedSchoolTypes.length === school_type_array.length
                    }
                  />
                }
                label="Select All"
              />
            </MenuItem>
            {school_type_array.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedSchoolTypes.includes(option.value)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedSchoolTypes([
                            ...selectedSchoolTypes,
                            option.value,
                          ]);
                        } else {
                          setSelectedSchoolTypes(
                            selectedSchoolTypes.filter(
                              (type) => type !== option.value
                            )
                          );
                        }
                      }}
                    />
                  }
                  label={option.label}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel id="checkbox-dropdown-label">District</InputLabel>
          <Select
            labelId="checkbox-dropdown-label"
            id="checkbox-dropdown"
            multiple
            label="Districts"
            value={selectedDistrictNames}
            onChange={() => {}}
            renderValue={(selected) => [...selected].join(", ")}
          >
            <MenuItem key="select-all" onClick={handleSelectAllChangeDistrict}>
              <FormControlLabel
                control={
                  <Checkbox
                    indeterminate={
                      selectedDistrictNames.length > 0 &&
                      selectedDistrictNames.length < district_names_array.length
                    }
                    checked={
                      selectedDistrictNames.length ===
                      district_names_array.length
                    }
                  />
                }
                label="Select All"
              />
            </MenuItem>
            {district_names_array.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedDistrictNames.includes(option.value)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedDistrictNames([
                            ...selectedDistrictNames,
                            option.value,
                          ]);
                        } else {
                          setSelectedDistrictNames(
                            selectedDistrictNames.filter(
                              (type) => type !== option.value
                            )
                          );
                        }
                      }}
                    />
                  }
                  label={option.label}
                />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <button
          onClick={handleFilterClick}
          className="bg-blue-500 rounded-md hover:bg-blue-700 w-[250px] text-white"
        >
          Submit
        </button>

        {/* <FormControl sx={{width: "50%"}}>
		<InputLabel id="checkbox-dropdown-label">Filter by Type</InputLabel>
		<Select
			labelId="checkbox-dropdown-label"
			id="checkbox-dropdown"
			multiple
			label="School Types"
			value={selectedSchoolTypes}
			onChange={() => {}}
			renderValue={(selected) => [...selected].join(', ')}
		>
			<MenuItem key="select-all" onClick={handleSelectAllChange}>
				<Checkbox
					indeterminate={
					selectedSchoolTypes.length > 0 &&
					selectedSchoolTypes.length < school_type_array.length
					}
					checked={selectedSchoolTypes.length === school_type_array.length}
			/>
			Select All
			</MenuItem>
			{school_type_array.map((option) => (
			<MenuItem key={option.value} value={option.value}>
				<FormControlLabel
				control={
					<Checkbox
					checked={selectedSchoolTypes.includes(option.value)}
					onChange={(e) => {
						if(e.target.checked){
							setSelectedSchoolTypes([...selectedSchoolTypes, option.value])
						}else{
							setSelectedSchoolTypes(selectedSchoolTypes.filter((type) => type !== option.value))
						}
					}}
					/>
				}
				label={option.label}
				/>
			</MenuItem>
			))}
		</Select>
	</FormControl>

	  	<FormControl sx={{width: "50%"}}>
			<InputLabel id="checkbox-dropdown-label">Filter by District</InputLabel>
			<Select
				labelId="checkbox-dropdown-label"
				id="checkbox-dropdown"
				multiple
				label="School Types"
				value={selectedDistrictNames}
				onChange={() => {}}
				renderValue={(selected) => [...selected].join(', ')}
			>
				<MenuItem key="select-all" onClick={handleSelectAllChangeDistrict}>
					<Checkbox
						indeterminate={
						selectedDistrictNames.length > 0 &&
						selectedDistrictNames.length < district_names_array.length
						}
						checked={selectedDistrictNames.length === district_names_array.length}
				/>
				Select All
				</MenuItem>
				{district_names_array.map((option) => (
				<MenuItem key={option.value} value={option.value}>
					<FormControlLabel
					control={
						<Checkbox
						checked={selectedDistrictNames.includes(option.value)}
						onChange={(e) => {
							if(e.target.checked){
								setSelectedDistrictNames([...selectedDistrictNames, option.value])
							}else{
								setSelectedDistrictNames(selectedDistrictNames.filter((type) => type !== option.value))
							}
						}}
						/>
					}
					label={option.label}
					/>
				</MenuItem>
				))}
			</Select>
		</FormControl>

	  <button onClick={handleFilterClick} className="bg-blue-500 rounded-md hover:bg-blue-700 w-[70px] text-white">
		Filter
	  </button> */}

        {/* <Autocomplete
      multiple
      disableCloseOnSelect
      options={blocks}
      getOptionLabel={(option) => option.block_name}
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          <Checkbox
            icon={icon}
            checkedIcon={checkedIcon}
            style={{ marginRight: 8 }}
            checked={selected}
            key={option.block_id}
          />
          {option.block_name}
        </li>
      )}
      sx={{flex: 1}}
      renderInput={params => <TextField {...params} label='Filter by Block'/>}
      /> */}
      </div>
      {schoolKPIByDistrict && <TopWidgets data={schoolKPIByDistrict} />}

      {isLoading && (
        <div className="flex justify-center items-center h-[50vh]">
          <PulseLoader color="#3B82F6" loading={isLoading} size={15} />
        </div>
      )}

      {!isLoading && schoolSummaryList && (
        <DataGrid
          columns={columns}
          rows={schoolSummaryList}
          rowHeight={50}
          pageSize={pageSize}
          rowsPerPageOptions={[25, 50, 100]}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          pagination
          sx={{ marginTop: "2.5em" }}
          autoHeight={true}
          getRowId={(row) => row.school_id}
          components={{
            Toolbar: CustomToolbar,
          }}
          initialState={{
            filter: {
              filterModel: {
                items: [
                  {
                    columnField: "school_name",
                    operatorValue: "contains",
                    value: "",
                  },
                ],
                quickFilterValues: [
                  sessionStorage.getItem("lastFilterNameSchool"),
                ],
              },
            },
          }}
          onFilterModelChange={(model) => {
            if (model.quickFilterValues.length > 0) {
              sessionStorage.setItem(
                "lastFilterNameSchool",
                model.quickFilterValues.join(" ")
              );
            } else {
              sessionStorage.setItem("lastFilterNameSchool", "");
            }
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        />
      )}
      <AddSchoolModal
        open={addSchoolModalOpen}
        setAddSchoolModalOpen={setAddSchoolModalOpen}
        setReload={setReload}
        schoolTypes={school_type_array}
        districts={district_names_array}
      />
    </div>
  );
};

export default Schools;
